/**
 * @module  experience/hardgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Routes } from '@angular/router';

// import {
//   BrowseDeviceLandingComponent
// } from '@experience/shop/hardgoods/components/browse-device-landing/browse-device-landing.component';

import { CompareDevicesComponent } from '@experience/shop/hardgoods/components/compare-devices/compare-devices.component';

// Services
import { BrowseDevicesLandingComponent } from '@experience/shop/hardgoods/components/browse-devices-landing-component/browse-devices-landing.component';
import { AccessoryCategoryDetailsComponent } from '@experience/shop/hardgoods/components/accessory-category-details/accessory-category-details.component';
import { BrowseAccessoryComponent } from '@experience/shop/hardgoods/components/browse-accessory/browse-accessory.component';

export const HARDGOODS_ROUTES: Routes = [
  {
    path: '',
    component: BrowseDevicesLandingComponent,
    children: [
      {
        path: 'accessoryCategory',
        component: BrowseAccessoryComponent,
      },
      {
        path: 'accessoryCategory/categoryDetails',
        component: AccessoryCategoryDetailsComponent,
      },
    ],
  },
  {
    path: 'compare-devices',
    component: CompareDevicesComponent,
  },
];
